'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _defineProperty2 = require('babel-runtime/helpers/defineProperty');

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends6 = require('babel-runtime/helpers/extends');

var _extends7 = _interopRequireDefault(_extends6);

exports.defaultProcessingOfActions = defaultProcessingOfActions;
exports.defaultLoadSubField = defaultLoadSubField;
exports.fillActionsListWithActions = fillActionsListWithActions;
exports.getInitialState = getInitialState;
exports.loadIfNeeded = loadIfNeeded;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// // Example of manually generated load function
// export function load(email) {
//   const userInfoPath = '/django/users/' + email + '/cameras/';
//   return dispatch => {
//     dispatch({
//       types: [LOAD, LOAD_SUCCESS, LOAD_FAIL],
//       email: email,
//       promise: (client) => client.get(userInfoPath).then(response => {
//         console.log('got a response!: ' + response);
//         if (response.results && response.results.map) {
//           response.results.map(camera => fetchRelevantCameraInfo(camera, dispatch));
//         }
//         dispatch(loadZendesk(email));
//         return response;
//       })
//     });
//   };
// }

var BASE_APP_ACTION = 'support-portal';

var LOAD_ACTION_KEY = 'LOAD';
var LOAD_SUCCESS_ACTION_KEY = 'LOAD_SUCCESS';
var LOAD_FAILURE_ACTION_KEY = 'LOAD_FAILURE';

function defaultProcessingOfActions(state, action, actionList) {
  var splitAction = action.type.split('/');
  var loadActionType = splitAction.pop();
  var actionKeyType = splitAction.pop();
  if (!(actionKeyType in actionList)) {
    console.log('Did not find ' + actionKeyType + ' inside of ' + actionList);
    return state;
  }

  switch (loadActionType) {
    case LOAD_ACTION_KEY:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, actionKeyType, (0, _extends7.default)({}, state[actionKeyType], {
        loading: true
      })));
    case LOAD_SUCCESS_ACTION_KEY:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, actionKeyType, (0, _extends7.default)({}, state[actionKeyType], {
        loading: false,
        loaded: true,
        result: action.result
      })));
    case LOAD_FAILURE_ACTION_KEY:
      return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, actionKeyType, (0, _extends7.default)({}, state[actionKeyType], {
        loading: false,
        loaded: false,
        error: action.error
      })));
    default:
      return state;
  }
}

function defaultLoadSubField(state, action, basePath, subReduxProcessor) {
  if (action.type.split('/')[1] === basePath) {
    return (0, _extends7.default)({}, state, (0, _defineProperty3.default)({}, action.id, subReduxProcessor(state[action.id], action)));
  }
  return state;
}

function fillActionsListWithActions(root, actionList) {
  var retActionList = actionList;
  // eslint-disable-next-line

  var _loop = function _loop(key) {
    if (actionList[key].actions === undefined) {
      retActionList[key].actions = [BASE_APP_ACTION + '/' + root + '/' + key + '/' + LOAD_ACTION_KEY, BASE_APP_ACTION + '/' + root + '/' + key + '/' + LOAD_SUCCESS_ACTION_KEY, BASE_APP_ACTION + '/' + root + '/' + key + '/' + LOAD_FAILURE_ACTION_KEY];
    }

    if (actionList[key].getObject === undefined) {
      retActionList[key].getObject = function (state, email) {
        return state.customers[email] && state.customers[email][key];
      };
    }

    if (actionList[key].dispatchFunction === undefined) {
      var thisAction = actionList[key];

      // eslint-disable-next-line no-loop-func
      retActionList[key].dispatchFunction = function (id, optionalPayload) {
        return function (dispatch) {
          var thisPromise = void 0;
          if (thisAction.promise === undefined) {
            thisPromise = function thisPromise(client) {
              return client.get(thisAction.getPath(id, optionalPayload));
            };
          } else {
            // If the user defines their own promise then
            // allow it to either be a function that is called
            // on success, or an array for success + failure
            // (By default we don't pass a failure handler)
            var userPromise = thisAction.promise(dispatch, id);
            var userReject = null;
            if (userPromise.constructor === Array) {
              userReject = userPromise[1];
              userPromise = userPromise[0];
            }

            // In this case we're executing the web-server query
            // as a promise and then allowing the redux action
            // to hook into then for an success or error handling
            thisPromise = function thisPromise(client) {
              return client.get(thisAction.getPath(id, optionalPayload)).then(userPromise, userReject);
            };
          }

          dispatch({
            types: thisAction.actions,
            id: id,
            promise: thisPromise
          });
        };
      };
    }
  };

  for (var key in actionList) {
    _loop(key);
  }
}

function getInitialState(actionList) {
  var retState = { loaded: false };

  // eslint-disable-next-line guard-for-in, no-restricted-syntax
  for (var key in actionList) {
    retState[key] = { loaded: false };
  }
  return retState;
}

function shouldFetch(state, email, subQuery) {
  var object = subQuery.getObject(state, email);
  if (!object) {
    return true;
  }
  if (object.loading || object.error) {
    return false;
  }
  return !object.loaded;
}

function loadIfNeeded(id, subQuery, optionalPayload) {
  return function (dispatch, getState) {
    if (shouldFetch(getState(), id, subQuery)) {
      if (subQuery.dispatchFunction !== null) {
        return dispatch(subQuery.dispatchFunction(id, optionalPayload));
      }
    }
    return _promise2.default.resolve();
  };
}


/*****************
 ** WEBPACK FOOTER
 ** ./src/redux/reduxUtils.js
 ** module id = 674
 ** module chunks = 0
 **/